<template>
  <fieldset class="tab tab-01 none-bg">
    <div class="heading-form a-center">
      <span class="number">1/10</span>
      <p class="c-yellow">สุขภาพทางการเงิน</p>
      <h2 class="heading-h2 c-white">
        จำนวนบุคคลที่อยู่ภายใต้การอุปการะเลี้ยงดูของคุณ
      </h2>
    </div>
    <div ng-app="apps" ng-controller="calchild" class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel"
              >พ่อ / แม่ / ญาติ / พี่น้อง</label
            >
            <div class="input-qty">
              <div class="qty-action qty-dec">
                <a class="qty-btn" @click="dec_parent()"></a>
              </div>
              <InputPattern
                type="text"
                v-model="parent"
                maxlength="2"
                :regExp="/^[\D]*|\D*/g"
                pattern="\d*"
                readonly
              />
              <div class="qty-action qty-inc">
                <a id="btnIncreaseRelative" class="qty-btn" @click="inc_parent()"></a>
              </div>
            </div>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel">ลูกชาย / ลูกสาว</label>
            <div class="input-qty">
              <div class="qty-action qty-dec">
                <a class="qty-btn" @click="dec_child()"></a>
              </div>
              <InputPattern
                type="text"
                v-model="child"
                maxlength="2"
                :regExp="/^[\D]*|\D*/g"
                pattern="\d*"
                readonly
              />
              <div class="qty-action qty-inc">
                <a id="btnIncreaseChildren" class="qty-btn" @click="inc_child()"></a>
              </div>
            </div>
          </div>
        </li>
        <li
          v-for="(v, index) in numRange(0, child)"
          :key="index"
          class="icw-field icw-field-full"
        >
          <div class="icw-input h-child">
            <label for="" class="icw-label overlabel txt-age">อายุลูก</label>
            <InputPattern
              :id="'txtAgeChildren'+[v]"
              type="text"
              v-model="child_age[v]"
              @blur="validAgeChild(child_age[v], v)"
              maxlength="2"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <label for="" class="icw-label overlabel txt-year">ปี</label>
          </div>
        </li>
      </ul>
    </div>
    <button
      id="btnNextStepQ2"
      type="button"
      name="next"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep2_Q1",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  data() {
    return {
      parent:
        my_storage(this.QuestionType, "parent") == ""
          ? 0
          : my_storage(this.QuestionType, "parent"),
      child:
        my_storage(this.QuestionType, "child") == ""
          ? 0
          : my_storage(this.QuestionType, "child"),
      child_age:
        my_storage(this.QuestionType, "child_age") == ""
          ? [0, 0, 0, 0, 0]
          : my_storage(this.QuestionType, "child_age")
    };
  },
  methods: {
    my_storage,
    nextStep,
    validAgeChild(value, key) {
      let a = my_storage("Information", "age");
      if (parseInt(value) >= parseInt(a)) {
        let b = a - 10;
        b = b <= 0 ? 0 : b;
        this.$nextTick(() => {
          this.child_age[key] = b;
          let tmp = this.child;
          this.child = [];
          this.child = tmp;
        });
      }
    },
    beforeNextStep() {
      let pass = true;

      if (this.child != "" && this.child > 0) {
        for (let i = 0; i < this.child; i++) {
          if (this.child_age[i] == "") pass = false;
        }
      }

      if (pass) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-01", "tab-02");
      }
      // this.nextStep('tab-01', 'tab-02')
    },
    dec_parent() {
      this.parent <= 0 ? 0 : this.parent--;
    },
    inc_parent() {
      this.parent++;
    },
    dec_child() {
      this.child <= 0 ? 0 : this.child--;
      for (let i = 0; i < 5; i++) {
        if (i >= this.child) {
          this.child_age[i] = 0;
        }
      }
    },
    inc_child() {
      if (this.child < 5) this.child++;
    },
    numRange: function(start, stop) {
      return new Array(stop - start).fill(start).map((n, i) => n + i);
    }
  },
  watch: {
    child: function(n, o) {
      this.child = n > 5 ? 5 : n;
    }
  },
  computed: {
    isPass() {
      let pass = true;
      let a = my_storage("Information", "age");
      if (this.child != "" && this.child > 0) {
        for (let i = 0; i < this.child; i++) {
          if (
            this.child_age[i] == "" ||
            parseInt(this.child_age[i]) >= parseInt(a)
          ) { pass = false; }
        }
      }

      return pass;
    }
  }
};
</script>
